import React, { Component } from 'react';
import RecetteGrid from '../components/RecetteGrid';


class  Recette extends Component  {


  render() {
 
  
        return ( 
            
            <section className="services-section-four">

                <div className='auto-container'>
                  
                        
                        <RecetteGrid />
                   


                </div>

            </section>
        )
    }
  }

export default Recette

